import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { Mail, ArrowLeft, KeyRound } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(data);
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <Link to="/login" className="inline-flex items-center gap-1 text-sm font-semibold hover:text-[var(--brand-primary)]">
          <ArrowLeft className="w-4 h-4" /> Back to sign in
        </Link>
        <div className="label-eyebrow mt-6 flex items-center gap-1.5"><KeyRound className="w-3 h-3" /> Account recovery</div>
        <h1 className="font-display font-black text-5xl tracking-tight mt-3">Forgot your<br /> password?</h1>
        <p className="text-[#5C5C5C] mt-3">Enter the email on your account. We'll send you a reset link if the email matches an account.</p>

        {!sent ? (
          <form onSubmit={submit} className="mt-10 space-y-5">
            <div>
              <label className="label-eyebrow block mb-2 flex items-center gap-1.5"><Mail className="w-3 h-3" /> Email</label>
              <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-[#0F0F0F] bg-transparent px-4 py-3 rounded-sm" placeholder="you@oceanash.org" />
            </div>
            {error && <div data-testid="forgot-error" className="text-sm text-[var(--brand-primary)]">{error}</div>}
            <button data-testid="forgot-submit" disabled={loading} type="submit" className="btn-terra w-full">
              {loading ? "Sending…" : "Send reset email"}
            </button>
          </form>
        ) : (
          <div className="mt-10 border border-[#0F0F0F] p-6" data-testid="forgot-success">
            <div className="font-display font-bold text-xl">Check your inbox.</div>
            <p className="text-sm text-[#5C5C5C] mt-2">
              If an account exists for that email, a reset link has been sent. The link expires in 1 hour.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
